"use client"

import React from "react"
import { Card } from "antd"

export default function ClassicTemplate({ cart: cartProp }) {
  const cart = cartProp || { items: [], total: 0, paid: 0, salesRepName: "" };

  const currenciesList = [
    {
      currSymbol: "$",
      symbolRightSide: "N",
    },
  ];
  const pricePrecision = 2;

  const totalItems = cart.items.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <div
      style={{
        height: "100vh",
        background: "#F3F4F6",
        overflow: "hidden",
      }}
    >
      <div style={{ height: "100%", maxWidth: 1200, margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 5 }}>
          <h1
            style={{
              fontSize: 36,
              fontWeight: "bold",
              color: "#1F2937",
              marginBottom: 8,
            }}
          >
            Order Summary
          </h1>
          <div
            style={{
              width: 96,
              height: 2,
              background: "#2563EB",
              margin: "0 auto",
            }}
          ></div>
        </div>

        {/* Main Content */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr", // Enforce three columns side by side
            gap: 32,
            height: "60%", // Matches h-5/6
          }}
          className="lg:grid-cols-3"
        >
          {/* Left Column - Info */}
          <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
            <Card
              title="Store Information"
              style={{ boxShadow: "0 10px 15px rgba(0,0,0,0.1)", flex: 1 }}
              styles={{ header: { background: "#2563EB", color: "#FFFFFF", textAlign: "center" }, body: { padding: 24, textAlign: "center" } }}
            >
              <div style={{ fontSize: 36, marginBottom: 16 }}>🏪</div>
              <h3 style={{ fontWeight: "bold", fontSize: 18, marginBottom: 8 }}>
                Premium Coffee Shop
              </h3>
              <p style={{ color: "#4B5563", fontSize: 14 }}>
                Serving quality since 1995
              </p>
            </Card>

            <Card
              title="Order Status"
              style={{ boxShadow: "0 10px 15px rgba(0,0,0,0.1)", flex: 1 }}
              styles={{ header: { background: "#16A34A", color: "#FFFFFF", textAlign: "center" }, body: { padding: 24, textAlign: "center" } }}
            >
              <div style={{ fontSize: 36, marginBottom: 16 }}>⏱️</div>
              <h3 style={{ fontWeight: "bold", fontSize: 18, marginBottom: 8 }}>
                Processing
              </h3>
              <p style={{ color: "#4B5563", fontSize: 14 }}>
                Your order is being prepared
              </p>
            </Card>
          </div>

          {/* Center Column - Items */}
          <div>
            <Card
              title="Order Items"
              style={{ height: "100%", boxShadow: "0 10px 15px rgba(0,0,0,0.1)" }}
              styles={{ header: { background: "#1F2937", color: "#FFFFFF", textAlign: "center" }, body: { padding: 24, height: "83.33%", overflowY: "auto" } }}
            >
              {cart.items.length === 0 ? (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ fontSize: 60, color: "#D1D5DB", marginBottom: 16 }}>
                    📋
                  </div>
                  <p style={{ color: "#6B7280", textAlign: "center" }}>
                    No items in your order
                  </p>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                  {cart.items.map((item) => (
                    <div
                      key={item.id}
                      style={{ borderBottom: "1px solid #E5E7EB", paddingBottom: 16 }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          marginBottom: 8,
                        }}
                      >
                        <h4 style={{ fontWeight: 600, color: "#1F2937" }}>
                          {item.name}
                        </h4>
                        <span style={{ fontWeight: "bold", color: "#2563EB" }}>
                          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                          {parseFloat(item.price * item.quantity).toFixed(pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: 14,
                          color: "#4B5563",
                        }}
                      >
                        <span>
                          {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                          {parseFloat(item.price).toFixed(pricePrecision)}
                          {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""} × {item.quantity}
                        </span>
                        <span>Qty: {item.quantity}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Card>
          </div>

          {/* Right Column - Total */}
          <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
            <Card
              title="Order Total"
              style={{ boxShadow: "0 10px 15px rgba(0,0,0,0.1)", flex: 1 }}
              styles={{ header: { background: "#F97316", color: "#FFFFFF", textAlign: "center" }, body: { padding: 24, textAlign: "center" } }}
            >
              <div style={{ fontSize: 36, marginBottom: 16 }}>💰</div>
              <div
                style={{
                  fontSize: 30,
                  fontWeight: "bold",
                  color: "#F97316",
                  marginBottom: 8,
                }}
              >
                {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                {parseFloat(cart.total).toFixed(pricePrecision)}
                {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
              </div>
              <p style={{ color: "#4B5563", fontSize: 14 }}>
                {totalItems} items total
              </p>
            </Card>

            <Card
              title="Thank You"
              style={{ boxShadow: "0 10px 15px rgba(0,0,0,0.1)", flex: 1 }}
              styles={{ header: { background: "#9333EA", color: "#FFFFFF", textAlign: "center" }, body: { padding: 24, textAlign: "center" } }}
            >
              <div style={{ fontSize: 36, marginBottom: 16 }}>🙏</div>
              <h3 style={{ fontWeight: "bold", fontSize: 18, marginBottom: 8 }}>
                We Appreciate You
              </h3>
              <p style={{ color: "#4B5563", fontSize: 14 }}>
                Thank you for choosing us!
              </p>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}